module.exports = __webpack_public_path__ + "img/vote_highest.cb49f054.svg";